module.exports = __webpack_public_path__ + "static/img/main2.666c0ffe.png";